var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", staticStyle: { "flex-grow": "1" } },
    [
      _c(
        "tab-customs-info-UICustom-layout",
        { attrs: { "element-blocks": _vm.elementBlocks } },
        [
          _vm.elementDict.customsBroker.viewable && !_vm.isSalesForSzfs
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(20% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "customsBroker" },
                  slot: "customsBroker"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsBroker.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsBroker.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.customsBroker.writable,
                      no: "customsBroker",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "data-filter-function": _vm.customsBrokerFilter,
                      filterable: "",
                      "default-value": _vm.job.customsBroker || "",
                      "method-params": {
                        customsBroker: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "latest-used-data-key":
                        _vm.elementDict.customsBroker.userCustomContent &&
                        _vm.elementDict.customsBroker.userCustomContent
                          .recentlyUsedDropdownData
                          ? "seaBooking-customsBroker"
                          : ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.customsBroker = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.advancePayment.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(20% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "advancePayment" },
                  slot: "advancePayment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.advancePayment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.advancePayment.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        value: _vm.job.advancePayment ? 1 : 0,
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.advancePayment.writable,
                        no: "advancePayment"
                      },
                      on: {
                        input: function(val) {
                          _vm.job.advancePayment = !!val
                        },
                        change: _vm.handleAdvancePaymentChange
                      }
                    },
                    _vm._l(_vm.SystemConstants.YESORNO_STATES, function(item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDutyAmount.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(20% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "customsDutyAmount" },
                  slot: "customsDutyAmount"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDutyAmount.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDutyAmount.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      no: "customsDutyAmount",
                      precision: 2,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.customsDutyAmount.writable,
                      min: 0
                    },
                    model: {
                      value: _vm.job.customsDutyAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customsDutyAmount", $$v)
                      },
                      expression: "job.customsDutyAmount"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vatAmount.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(20% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "vatAmount" },
                  slot: "vatAmount"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vatAmount.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vatAmount.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      no: "vatAmount",
                      precision: 2,
                      disabled:
                        _vm.readonly || !_vm.elementDict.vatAmount.writable,
                      min: 0
                    },
                    model: {
                      value: _vm.job.vatAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "vatAmount", $$v)
                      },
                      expression: "job.vatAmount"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTime.viewable
            ? _c(
                "el-form-item",
                {
                  staticStyle: {
                    width: "calc(20% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "paymentTime" },
                  slot: "paymentTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTime.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      no: "paymentTime",
                      disabled:
                        _vm.readonly || !_vm.elementDict.paymentTime.writable,
                      type: "date",
                      clearable: "",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.job.paymentTime,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "paymentTime", $$v)
                      },
                      expression: "job.paymentTime"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsRemarks.viewable
            ? _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  staticStyle: {
                    width: "calc(20% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "customsRemarks" },
                  slot: "customsRemarks"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsRemarks.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsRemarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.customsRemarks.writable,
                      no: "customsRemarks",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Remarks"),
                          _vm.job.customsRemarks,
                          function(val) {
                            _vm.job.customsRemarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.customsRemarks,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customsRemarks", $$v)
                      },
                      expression: "job.customsRemarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.taxRemarks.viewable
            ? _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  staticStyle: {
                    width: "calc(20% - 15px)",
                    "margin-right": "10px"
                  },
                  attrs: { slot: "taxRemarks" },
                  slot: "taxRemarks"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.taxRemarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.taxRemarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      disabled:
                        _vm.readonly || !_vm.elementDict.taxRemarks.writable,
                      no: "taxRemarks",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.TaxRemarks"),
                          _vm.job.taxRemarks,
                          function(val) {
                            _vm.job.taxRemarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.taxRemarks,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "taxRemarks", $$v)
                      },
                      expression: "job.taxRemarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "template",
            { slot: "customsProcedures" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.previewConfig && _vm.cooperateEdit,
                      expression: "!previewConfig && cooperateEdit"
                    }
                  ],
                  staticStyle: { display: "flex", margin: "5px 0" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "NewCustomsDeclaration",
                        type: "primary",
                        disabled:
                          !_vm.btnEnable ||
                          (_vm.isEdit && _vm.openXhqCustomsAll)
                      },
                      on: { click: _vm.addCustInfoHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.NewCustomsDeclaration")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "EditCustomsDeclaration",
                        type: "primary",
                        disabled:
                          !_vm.btnEnable ||
                          (_vm.isEdit &&
                            (_vm.openXhqCustoms || _vm.openXhqCustomsAll))
                      },
                      on: { click: _vm.editCustInfoHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.EditCustomsDeclaration")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.openXhqCustomsAll,
                          expression: "!openXhqCustomsAll"
                        }
                      ],
                      attrs: {
                        no: "DeleteCustomsDeclaration",
                        type: "danger",
                        disabled: !_vm.btnEnable
                      },
                      on: { click: _vm.delCustInfoHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.DeleteCustomsDeclaration"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.openXhqCustomsAll,
                          expression: "openXhqCustomsAll"
                        },
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_customs_forceDelete"],
                          expression: "['button_customs_forceDelete']"
                        }
                      ],
                      attrs: {
                        no: "xhqDeleteCustomsDeclaration",
                        type: "danger",
                        disabled: !_vm.btnEnable || _vm.isEdit
                      },
                      on: { click: _vm.xhqDelCustInfoHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.DeleteCustomsDeclaration"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.openXhqCustomsAll,
                          expression: "openXhqCustomsAll"
                        }
                      ],
                      attrs: {
                        no: "xhqCustomsUnFrozen",
                        type: "primary",
                        disabled: !_vm.btnEnable || _vm.isEdit
                      },
                      on: { click: _vm.toXhqCustomsUnFrozenHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.UnFrozen")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.openXhqCustoms || _vm.openXhqCustomsAll,
                          expression: "openXhqCustoms || openXhqCustomsAll"
                        }
                      ],
                      attrs: {
                        no: "GetCustomsFile",
                        type: "primary",
                        disabled:
                          !_vm.btnEnable ||
                          !(_vm.job.jobState === 0) ||
                          _vm.isEdit
                      },
                      on: { click: _vm.getCustomsFile }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.GetFiles")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.closeXhqCustoms &&
                            !_vm.openOujianCustoms &&
                            _vm.job.lob === "SE",
                          expression:
                            "closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'"
                        }
                      ],
                      attrs: {
                        no: "GetOcrFile",
                        type: "primary",
                        disabled:
                          _vm.job.jobState !== 0 ||
                          _vm.isEdit ||
                          !_vm.$checkPermission([
                            "button_customs_IdentifyTheCustoms"
                          ])
                      },
                      on: { click: _vm.getOcrFileHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_IdentifyTheCustomsDeclaration")
                        )
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.closeXhqCustoms &&
                            !_vm.openOujianCustoms &&
                            _vm.job.lob === "SE",
                          expression:
                            "closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'"
                        }
                      ],
                      attrs: {
                        no: "RefreshOcrFile",
                        type: "primary",
                        disabled: _vm.job.jobState !== 0 || _vm.isEdit
                      },
                      on: { click: _vm.loadList }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_RefreshCustomsDeclaration")
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "grid-params": _vm.gridParams,
                  "config-module": _vm.closeXhqCustoms
                    ? "20240830"
                    : "20240831",
                  "column-defs": _vm.closeXhqCustoms
                    ? _vm.columnDefs
                    : _vm.xhqColumnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c("customs-info-dialog", {
        ref: "customsInfoDialog",
        attrs: {
          "customs-infos": _vm.rowData,
          "slave-customs-declaration-enable": _vm.slaveCustomsDeclarationEnable,
          visible: _vm.editDialog.visible,
          "is-sales-for-szfs": _vm.isSalesForSzfs,
          "selected-customs-info": _vm.selectedCustomsInfo,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler,
          loadList: _vm.loadList
        }
      }),
      _c("customs-info-dialog-ouj", {
        ref: "customsInfoDialogOuj",
        attrs: {
          visible: _vm.editOujianDialog.visible,
          "selected-customs-info": _vm.editOujianDialog.customsInfo,
          job: _vm.editOujianDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editOujianDialog, "visible", $event)
          },
          successHandler: _vm.successHandler,
          close: function($event) {
            _vm.editOujianDialog.visible = false
          }
        }
      }),
      _c("customs-info-interact-res-dialog", {
        ref: "customsInfoInteractResDialog",
        attrs: {
          visible: _vm.interactResDialog.visible,
          "customs-id": _vm.interactResDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.interactResDialog, "visible", $event)
          }
        }
      }),
      _c("file-history-dialog", {
        ref: "fileHistoryDialog",
        attrs: {
          visible: _vm.fileHistoryDialog.visible,
          "customs-id": _vm.fileHistoryDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("information-comparison-dialog", {
        ref: "informationComparisonDialog",
        attrs: {
          visible: _vm.informationComparisonDialog.visible,
          data: _vm.informationComparisonDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.informationComparisonDialog, "visible", $event)
          }
        }
      }),
      _c("customs-receipt-record-dialog", {
        ref: "customsReceiptRecordDialog",
        attrs: {
          visible: _vm.customsReceiptRecordDialog.visible,
          "selected-customs-info": _vm.customsReceiptRecordDialog.customsInfo
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsReceiptRecordDialog, "visible", $event)
          }
        }
      }),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.job.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceText",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "warning-count": -1,
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.closeXhqCustoms && !_vm.openOujianCustoms && _vm.job.lob === "SE"
        ? _c("drop-uploader", {
            ref: "dropUploader",
            attrs: {
              action: _vm.URL.AIdiscern.importAndAnalyseFile,
              "upload-params": {
                source: _vm.INTELLIGENT_DOCUMENT_SOURCE_9.code,
                iChannel: 3,
                jobUuid: _vm.job.uuid,
                pageSource: "customsInfo",
                officeId: _vm.$store.getters.currentOfficeId
              },
              accept: [
                "pdf",
                "xls",
                "xlsx",
                "doc",
                "docx",
                "jpg",
                "gif",
                "png",
                "tif",
                "msword",
                "ms-excel",
                "jpeg",
                "rtf"
              ],
              "file-format": _vm.fileFormat,
              multiple: false,
              "open-drag": false,
              "bs-open": _vm.bsOpen
            },
            on: { "upload-result": _vm.uploadResultHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }